// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Surface-module__root--VPkjk {
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #f7f2ec;
  background-color: #f7f2ec;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Surface/Surface.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[".root {\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border: 1px solid #f7f2ec;\n  background-color: #f7f2ec;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Surface-module__root--VPkjk`
};
export default ___CSS_LOADER_EXPORT___;
